import React, { useEffect, useState } from 'react';
import { Stack, Typography } from "@mui/material";
import { AnsweredQuestion } from '../../../contexts/DashboardContext';
import { splitter } from '../../../helpers/textSplitter';
import { NoInfoYet } from '../../../types/search';
import theme from '../../../theme';

const DescriptionAnswer: React.FC<{
    answeredQuestion: AnsweredQuestion,
    onModal?: (open: boolean) => void,
 }> = ({ answeredQuestion, onModal }) => {
    const [sentences, setSentences] = useState<string[]>([]);

    useEffect(() => {
        if (typeof answeredQuestion.answer === 'string')
            setSentences(splitter(answeredQuestion.answer as string).map((split) => split.sent));
    }, [answeredQuestion]);

    return (<>
        <Stack direction="column" spacing={1} alignItems="baseline" mb={1}>
            <Typography fontFamily="Inter" color="#666666">
                {!!sentences.length ? (sentences[0]) : (NoInfoYet.answer)}
            </Typography>
            <Typography
                component="span"
                fontFamily="Inter"
                fontSize="1rem"
                fontWeight={700}
                color={theme.palette.primary.light}
                onClick={() => onModal?.(true)}
                sx={{ cursor: 'pointer' }}>
                    {'See more'}
            </Typography>
        </Stack>
    </>);
}

export default DescriptionAnswer;
